import React from 'react'

import multimedia from './../../../UI/general/BikeMenu/multimedia.svg'
import personaliza from './../../../UI/general/BikeMenu/personaliza.svg'
import ficha from './../../../UI/general/BikeMenu/ficha.svg'
import formulario from './../../../UI/general/BikeMenu/formulario.svg'

interface Props{
    selectedBike: any
    selectedIndividualBike: boolean,
    handleOpenMultimedia: any,
    handleOpenSpin: any,
    handleOpenFichaTecnica: any,
    handleOpenFormulario: any,
    isMultimediaOpened: boolean,
    isSpinOpened: boolean,
    isFichaOpened: boolean,
    isFormularioOpened: boolean
} 

interface State{}

class BikeBarMobile extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
        }
    }

    render(){
        return(
            <div className={this.props.selectedIndividualBike ? "bike-menu-opened":"bike-menu-collapsed"}>
                {
                    this.props.selectedIndividualBike ? 
                <React.Fragment>
                    <div className='bike-options-container-mobile'>
                        <div className={this.props.isMultimediaOpened ? 'individual-option-container  individual-selected':'individual-option-container'} onClick={() => {this.props.handleOpenMultimedia(true)}}>
                            <img src={multimedia}/>
                            <div>Multimedia</div>
                        </div>
                        <div className={this.props.isSpinOpened ? 'individual-option-container  individual-selected':'individual-option-container'} onClick={this.props.handleOpenSpin}>
                            <img src={personaliza}/>
                            <div>Personaliza</div>
                        </div>
                        <div className={this.props.isFichaOpened ? 'individual-option-container  individual-selected':'individual-option-container'} onClick={() => {this.props.handleOpenFichaTecnica(true)}}>
                            <img src={ficha}/>
                            <div>Ficha Técnica</div>
                        </div>
                        {/*
                        <div className={this.props.isFormularioOpened ? 'individual-option-container  individual-selected':'individual-option-container'} onClick={this.props.handleOpenFormulario}>
                            <img src={formulario}/>
                            <div>Formulario</div>
                        </div>
                        */}
                    </div>
                </React.Fragment>:null
                }
            </div>
        )
    }
} 

export default BikeBarMobile